module.exports = {"data":{"site":{"siteMetadata":{"ru":{"title":"Фэйк Авиабилеты"}}}},"pathContext":{"slug":"/ru/terms/","langKey":"ru"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/ru-terms.json
// module id = 903
// module chunks = 145692147492288